import React, { useState } from "react";
import menu from "../assets/images/menu.png";
import logo from "../assets/images/logo.png";
import SocialMedia from "./SocialMedia";

function Nav() {
  const [showNav, setshowNav] = useState(false);
  return (
    <header className="max-w-[1880px]  z-10 shadow-xl fixed top-[30px] bg-black left-[50%] translate-x-[-50%] m-auto w-[90%] p-2 px-8  rounded-lg max-md:p-3 max-md:px-4 max-sm:px-7 ">
      <nav className="flex justify-between items-center ">
        <a className="flex items-start  flex-1 max-md:flex-[0.5] max-sm:flex-[0.33] ">
          <img
            src={logo}
            alt="logo"
            className="h-[50px] w-[80px] max-sm:h-[40px] max-sm:w-[70px] object-contain  cursor-pointer "
          />
        </a>
        <ul className="nav flex items-center justify-between  flex-1 text-white max-lg:flex-[1.5]">
          <li>
            <a className="font-black italic text-[20px] uppercase" href="#hero">
              Home
            </a>
          </li>
          <li>
            <a
              className="font-black italic text-[20px] uppercase"
              href="#about"
            >
              About Me
            </a>
          </li>
          <li>
            <a
              className="font-black italic text-[20px] uppercase"
              href="#project"
            >
              Projects
            </a>
          </li>
          <li>
            <a
              className="font-black italic text-[20px] uppercase"
              href="#contact"
            >
              Contact
            </a>
          </li>
        </ul>
        {showNav ? (
          <button
            className="text-[25px]  text-white"
            onClick={() => setshowNav(false)}
          >
            X
          </button>
        ) : (
          <img
            src={menu}
            alt="menu"
            className="menu cursor-pointer"
            onClick={() => setshowNav(true)}
          />
        )}
        <div className="nav_btn_holder flex  justify-end max-md:flex-2 flex-1 max-md:justify-center">
          <SocialMedia />
        </div>
      </nav>
      {showNav && (
        <ul className="navMobile border h-[fit-content] rounded-xl w-[50%] max-sm:w-[70%] shadow-xl  right-0 top-[102%] z-10 fixed bg-black p-5 ">
          <li className="my-5 ">
            <a className="font-bold text-white" href="#hero">
              Home
            </a>
          </li>
          <li className="my-5 ">
            <a className="font-bold text-white" href="#about">
              About Me
            </a>
          </li>
          <li className="my-5 ">
            <a className="font-bold text-white" href="#project">
              Projects
            </a>
          </li>
          <li className="my-5 ">
            <a className="font-bold text-white" href="#contact">
              Contact
            </a>
          </li>
          <div className=" flex justify-center items-center  max-md:justify-center pt-4">
            <SocialMedia />
          </div>
        </ul>
      )}
    </header>
  );
}

export default Nav;
